import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings/hexColors'
import { spacing } from '@mobi/component-library/Theme/Common'
import { QuickbetButtonStyled } from '@core/Areas/Quickbet/Components/Buttons/Components/Common.styles'

export const RecieptContainerStyled = styled.div({
  border: `0.1rem solid ${hexColors.veryLightGrey}`,
  backgroundColor: hexColors.white,
  padding: spacing.sm,
})

export const RecieptButtonsContainerStyled = styled.div({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  gap: '1rem',
  marginTop: '1rem',

  '> *': { flex: 1, flexBasis: 'calc(50% - 1rem)' },

  svg: { maxWidth: '1.6rem' },

  ':empty': { display: 'none' },
})

export const ReceiptButtonStyled = styled(QuickbetButtonStyled)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: spacing.smx2,
})
